<x-swiper
  #SWIPER_COMPONENT
  [slideTemplate]="itemTemplate"
  [slides]="products"
  [swiperOptions]="swiperOptions"
  (onSlideChange)="onSlideChange.emit($event)"
  (onActiveIndexChange)="onActiveIndexChange.emit($event)"
  (onReachEnd)="onReachEnd.emit($event)"
  (nextClickEvent)="onNextClickEvent.emit($event)"
>
  <ng-template #itemTemplate let-item>
    <x-product-card
      [product]="item"
      [associationId]="associationId"
      [associationOrigin]="associationOrigin"
      [origin]="origin"
      [taxonId]="taxonId"
      [listName]="listName"
    ></x-product-card>
  </ng-template>
</x-swiper>

<x-loader *ngIf="loading"></x-loader>

@if (moreProductsByIndex) {
  @for (item of moreProductsByIndex | keyvalue; track item.key) {
    <div #MORE_SLIDE_GROUPS class="more-slides-group" [id]="'group-index-' + item.key">
      @for (item of item.value; track item.id) {
        <x-swiper-slide>
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }"
          ></ng-container>
        </x-swiper-slide>
      }
    </div>
  }
}

<ng-template #itemTemplate let-item>
  <x-product-card
    [product]="item"
    [associationId]="associationId"
    [associationOrigin]="associationOrigin"
    [origin]="origin"
    [taxonId]="taxonId"
    [listName]="listName"
  ></x-product-card>
</ng-template>
